<template>
    <div id="template-manager" class="container-fluid main-content page-content">
        <div class="page-header">
            <div>
                <h3 class="page-title">{{ $t('template') }}</h3>
            </div>
        </div>
        <div class="page-card">
            <div class="row justify-content-between px-3 py-1">
                <div class="col-6">
                    <div class="position-relative w-75">
                        <input
                            type="text"
                            class="form-control text-small py-1 pr-4"
                            v-model="search"
                            :placeholder="$t('search')"
                        >

                        <span
                            v-if="search"
                            class="clear-search"
                            @click="search = ''"
                        >
                            &times;
                        </span>
                    </div>
                </div>
                <div class="col-3 d-flex justify-content-end">
                    <button class="btn btn-primary rounded-pill d-flex style-btn" @click="$bvModal.show('template-sidebar'), isEdit = false">
                        <span class="spinner-border spinner-border-sm mt-1 mr-1" role="status" aria-hidden="true" v-if="loading"></span>
                        {{ $t('add-template') }}
                    </button>
                </div>
            </div>
            <base-table
                class="mt-2"
                :columns="columns"
                :items="filteredList"
                :loading="firstLoading"
                :empty-text="search ? $t('no-template-found') : $t('no-template')"
                fill
            >
                <template #cell(actions)="{ item }">
                    <button
                        type="button"
                        class="base-table-action"
                        :aria-label="$t('edit')"
                        @click="editTemplate(item.id, item.attributes.name, item.attributes.content)"
                    >
                        <font-awesome-icon :icon="['fas', 'pencil-alt']" />
                    </button>
                    <button
                        type="button"
                        class="base-table-action base-table-action-danger"
                        :aria-label="$t('delete')"
                        @click="removeTemplate(item.id, item.attributes.name)"
                    >
                        <font-awesome-icon :icon="['fas', 'times']" />
                    </button>
                </template>
            </base-table>
        </div>
        <template-modal
            v-bind:isEdit="isEdit"
        ></template-modal>
    </div>
</template>
<script>

// Internal componants
import Alert                from '../../helpers/Alert.js';
import TemplateModal        from './TemplateModal.vue';
import BaseTable            from './BaseTable.vue';

// Import external libraries
import { mapActions, mapState } from 'vuex';
import _                          from 'underscore';

// Import Really Fast Deep Copy
const clone = require('rfdc')();

export default {
    components: {
        TemplateModal,
        BaseTable
    },

    data () {
        return {
            loading:      false,
            search:       '',
            firstLoading: false,
            isEdit:       false
        };
    },
    created () {
        // Show the preloader.
        this.firstLoading = true;

        // Get the temaplate
        this.getTemplate()
            .then(() => {
                // Hide the preloader.
                this.firstLoading = false;
            });
    },
    computed: {
        ...mapState('core/templates', {
            templates:        'templates',
            selectedTemplate: 'selectedTemplate'
        }),

        /**
         * Search template in the list
         */
        columns () {
            return [
                {
                    key:     'attributes.name',
                    label:   this.$t('template-name'),
                    thStyle: { width: '30%' },
                    tdClass: 'cell-ellipsis'
                },
                {
                    key:     'attributes.content',
                    label:   this.$t('preset-message'),
                    tdClass: 'cell-ellipsis'
                },
                {
                    key:     'actions',
                    label:   '',
                    thStyle: { width: '120px' },
                    tdClass: 'cell-actions'
                }
            ];
        },

        filteredList () {
            // Generates a filtered array from the template list
            return clone(_.filter(this.templates, template => (template.attributes.name.toLowerCase().includes(this.search.toLowerCase()) || template.attributes.content.toLowerCase().includes(this.search.toLowerCase()))));
        }
    },
    methods: {
        ...mapActions('core/templates', {
            getTemplate:    'index',
            selectTemplate: 'select',
            createTemplate: 'create',
            patchTemplate:  'update',
            deleteTemplate: 'delete'
        }),

        /**
         * Delete selected template
         *
         * @param   {string}   ID    The Id of the selected template.
         * @param   {string}   name  The name of the selected template.
         *
         */
        removeTemplate (templateId, templateName) {
            this.$dialog.confirm({
                title:       this.$t('title-template-delete'),
                subject:     templateName,
                text:        this.$t('confirm-template-delete'),
                centerText:  true,
                confirmText: this.$t('delete'),
                danger:      true,
                onConfirm:   () => this.deleteTemplate({ id: templateId })
            })
                .catch(() => {
                    Alert.fail(this.$i18n.t('default-error'));
                });
        },

        // Send template to edit modal
        editTemplate (templateId, templateName, templateContent) {
            this.isEdit = true;
            this.selectTemplate({
                id:      templateId,
                name:    templateName,
                content: templateContent
            })
                .then(() => {
                    this.$bvModal.show('template-sidebar');
                });
        }
    }
};
</script>
